module.exports = __webpack_public_path__ + "static/media/requests.d8a516e3.svg";